export default "__VITE_ASSET__pVxtV8Y5__"